// extracted by mini-css-extract-plugin
module.exports = {"container":"v","title":"w","buttonGroup":"x","buttonWrapper":"y","cancelButton":"z","confirmButton":"A","error":"B"};